// hooks/useYoutubeEmbed.js
import { useState, useEffect } from "react";

const useYoutubeEmbed = (apiEndpoint, fallbackId) => {
  const [youtubeId, setYoutubeId] = useState(fallbackId);

  useEffect(() => {
    fetch(apiEndpoint)
      .then(res => res.json())
      .then(data => {
        if (data.youtube_id) setYoutubeId(data.youtube_id);
      })
      .catch(() => {});
  }, [apiEndpoint]);

  const embedUrl = `https://www.youtube.com/embed/${youtubeId}?autoplay=1&mute=1&loop=1&playlist=${youtubeId}&controls=0&modestbranding=1`;

  return embedUrl;
};

export default useYoutubeEmbed;